export default "__VITE_ASSET__mcBYKf1C__"